import currentAccounts from "@/store/currentAccounts/currentAccounts.js";

class concepts {
  constructor(
    conceptId,
    costCenterId,
    nameConcept,
    debCred,
    formula,
    nameCostCenter,
    paramA,
    paramB
  ) {
    this.conceptId = conceptId;
    this.costCenterId = costCenterId;
    this.nameConcept = nameConcept;
    this.debCred = debCred;
    this.formula = formula;
    this.nameCostCenter = nameCostCenter;
    this.paramA =
      currentAccounts.state.edit.unit === "D"
        ? paramA
        : this.convertToTime(paramA);
    this.paramB = paramB;
  }
  static fromJson({
    conceptoId,
    csCostoId,
    nomConcepto,
    debCred,
    formula,
    nomCsCosto,
    paramA,
    paramB,
  }) {
    return new concepts(
      conceptoId,
      csCostoId,
      nomConcepto,
      debCred,
      formula,
      nomCsCosto,
      paramA,
      paramB
    );
  }
  convertToTime(minutes) {
    const hours = Math.floor(minutes / 60)
      .toString()
      .padStart(2, "0");
    const mins = (minutes % 60).toString().padStart(2, "0");
    return `${hours}:${mins}`;
  }
}

export default concepts;
